import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MarketingIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_589_3129)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.0518 1.37988L17.1317 11.9105",
                        stroke: color || "#676879",
                        strokeWidth: "1.43882",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M16.8157 11.3578L1.8281 14.8379L0.868164 13.1751L11.3759 1.93555",
                        stroke: color || "#676879",
                        strokeWidth: "1.43882",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M5.08789 14.0794L5.91317 15.5088C6.21256 16.022 6.70352 16.3952 7.27807 16.5463C7.85259 16.6973 8.46364 16.6141 8.97676 16.3146C9.4899 16.0153 9.86308 15.5244 10.0142 14.9498C10.1653 14.3753 10.0821 13.7642 9.78267 13.2511L9.6505 13.0222",
                        stroke: color || "#676879",
                        strokeWidth: "1.43882",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_589_3129",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
